import React, { useEffect, useState, useMemo } from 'react'
import { Select } from 'antd';
import { useLocation } from 'react-router-dom';

import { columnsList } from '../components/TableType'
import MyTable from "../components/MyTable"
import MyCheckBox from "../components/MyCheckBox"
import MyApi from "../actions/RequestApi";

import '../styles/BucketPage.css'

//数据table展示页
export default function BucketPage() {
    const [columnsData, setColumnsData] = useState([])
    const [bucketData, setBucketData] = useState([])
    const location = useLocation();

    function handleEmptyData(bucket, obj) {
        let metaColumnArr = columnsList.find(v => v.bucket === bucket);
        if (!metaColumnArr) return null
        let column = metaColumnArr.columns
        for (let i = 0; i < column.length; i++) {
            let key = column[i].key
            if (obj[key] === undefined) {
                if (column[i].type === 'boolean') obj[key] = false
                else if (column[i].type === 'string') obj[key] = ''
                else if (column[i].type === 'number') obj[key] = 1
            }
            else {
                if (column[i].type === 'boolean' && obj[key] === '') obj[key] = false
                else if (column[i].type === 'number') obj[key] = Number(obj[key])
                else if (column[i].type === 'array' && typeof obj[key] === 'string') {
                    obj[key] = obj[key].split(',')
                }

                // if (obj[key] === 'false') obj[key] = false
                // else if (obj[key] === 'true') obj[key] = true
            }
        }
        console.log('还原处理后的', obj);
        return obj
    }

    //api修改数据库
    const updateInfo = async (obj) => {
        if (location.state.includes('bucket-')) {
            obj = handleEmptyData(location.state, obj);
            const api = new MyApi(location.state, obj.name)
            if (location.state === 'bucket-tickets-docker') delete obj.name
            let res = await api.updateInfo(obj);
            return res
        }
        else {
            // obj = handleEmptyData(location.state, obj);
            // let list = bucketData

            // let keyInd
            // if (obj.name) keyInd = list.findIndex(v => v.name === obj.name)
            // else keyInd = list.findIndex(v => v.id === obj.id)
            // console.log(keyInd,list[keyInd]);
            // if(keyInd) return false
            // list[keyInd] = obj
            // const api = new MyApi('json-bucket', location.state);
            // let res = await api.updateInfo(list);
            // return res

            obj = handleEmptyData(location.state, obj);
            let list = [...bucketData]
            list[obj.id] = obj
            const vpnApi = new MyApi('json-bucket', location.state);
            let res = await vpnApi.updateInfo(list);
            return res
        }
    }
    //api删除数据库
    const deleteInfo = async (obj) => {
        if (location.state.includes('bucket-')) {
            const deleteApi = new MyApi(location.state, obj.name);
            let res = await deleteApi.removeInfo(obj);
            return res
        }
        else {
            const newData = bucketData.filter((item) => item.key !== obj.key);
            const deleteApi = new MyApi('json-bucket', location.state);
            let res = await deleteApi.updateInfo(newData);
            return res
        }
    }
    //api加载数据库
    const loadBucket = async (bucket) => {
        if (bucket.includes('bucket-')) {
            const api = new MyApi(bucket, 'all')
            let res = await api.getAllInfo();
            let rdata = creatData(res);
            setBucketData([...rdata]);
        }
        else {
            const api = new MyApi('json-bucket', bucket)
            let res = await api.getInfo();
            let rdata = creatData(res);
            setBucketData([...rdata]);
        }
        setColumnsData(getColumns(location.state));
    }

    //将数据库内容转换成表格渲染用的数据
    const creatData = (arr) => {
        let dataArr = []
        //分配key
        for (let i = 0; i < arr.length; i++) {
            //是json还是对象
            if (!arr[i]) continue
            if (arr[i].content) {
                let jsonData = JSON.parse(arr[i].content);
                if (location.state === 'bucket-tickets-docker') {
                    jsonData.name = arr[i].fileName.replace('.json', '');
                }

                if (jsonData.name) {
                    jsonData.key = jsonData.name;
                }
                else {
                    jsonData.key = jsonData.id
                }
                dataArr.push(jsonData);
            }
            else {
                if (arr[i].name) {
                    arr[i].key = arr[i].name;
                }
                else {
                    arr[i].key = arr[i].id
                }
                dataArr.push(arr[i]);
            }

        }
        console.log(dataArr);
        return dataArr
    }

    //修改数据实时显示
    const checkCallback = (arr) => {
        let target = getColumns(location.state);
        let output = []
        for (let i = 0; i < arr.length; i++) {
            let res = target.find(v => v.dataIndex === arr[i]);
            console.log(res);
            output.push(res);
        }
        setColumnsData([...output]);
    }

    //获取table各项配置
    const getColumns = (type) => {
        let target = columnsList.find(v => v.bucket === type)
        if (target) return target.columns
        else return []
    }

    //初始化加载bucket
    useEffect(() => {
        loadBucket(location.state);
        // console.log(location.state);
    }, []);

    const table = useMemo(() => {
        if (bucketData.length > 0) return <MyTable bucketArr={bucketData} columns={columnsData} updateInfo={updateInfo} deleteInfo={deleteInfo} />
    }, [bucketData, columnsData])

    return (
        <>
            <div id='solve'>
                <div className='bucket-title'>{location.state}</div>
                <Select
                    defaultValue="Columns"
                    style={{
                        width: 120,
                        float: 'right',
                        margin: '0 15px 15px 0'
                    }}
                    options={[]}
                    dropdownRender={(menu) => (
                        <MyCheckBox optionData={getColumns(location.state)} checkCallback={checkCallback} />
                    )}
                />
                {table}
            </div>
        </ >
    )
}

